import { actionConstants } from './actionConstants';
import noti from './toast';
import { get, post, put, _delete } from './method';

export default {
  resetStore,
  getMobileConfigs,
  getMobileConfigsByDeptId,
  getSpecificMobileConfig,
  createMobileConfig,
  editMobileConfig,
  copyMobileConfig,
  deleteMobileConfig,
  getSensorsByMobileConfigId,
  configSensors,
  saveMobileConfigId,
};

function resetStore() {
  return (dispatch) => {
    dispatch({ type: actionConstants.INIT_STATE });
  };
}

function getMobileConfigs() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/mobileConfigurations`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MOBILE_CONFIGS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_MOBILE_CONFIGS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getMobileConfigsByDeptId(deptId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/mobileConfigurations/by-department/${deptId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MOBILE_CONFIGS_BY_DEPT_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_MOBILE_CONFIGS_BY_DEPT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificMobileConfig(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/mobileConfigurations/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MOBILE_CONFIG_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_MOBILE_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function createMobileConfig(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post(`app/mobileConfigurations`, params)
      .then((resp) => {
        noti.success('Mobile configuration is created');
        dispatch({
          type: actionConstants.CREATE_MOBILE_CONFIG_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_MOBILE_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function editMobileConfig(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/mobileConfigurations/${id}`, params)
      .then((resp) => {
        noti.success('Mobile configuration is updated');
        dispatch({
          type: actionConstants.EDIT_MOBILE_CONFIG_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_MOBILE_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function copyMobileConfig(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post(`app/mobileConfigurations/${id}/copy`, params)
      .then((resp) => {
        noti.success('Mobile configuration is copied');
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function deleteMobileConfig(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await _delete(`app/mobileConfigurations/${id}`)
      .then((resp) => {
        noti.success('Mobile configuration is removed');
        dispatch({
          type: actionConstants.DELETE_MOBILE_CONFIG_SUCCESS,
          data: resp,
        });
        return;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_MOBILE_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSensorsByMobileConfigId(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.INIT_STATE });
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/mobileConfigurations/${id}/sensors`)
      .then((resp) => {
        dispatch({
          type: actionConstants.SENSORS_BY_MOBILE_CONFIG_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.SENSORS_BY_MOBILE_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function configSensors(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/mobileConfigurations/${id}/sensors`, params)
      .then((resp) => {
        noti.success('Sensors are configured');
        dispatch({
          type: actionConstants.CONFIG_MOBILE_SENSORS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CONFIG_MOBILE_SENSORS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function saveMobileConfigId(mobileConfigId) {
  return () => {
    try {
      if (mobileConfigId === 'default') {
        localStorage.removeItem('mobileConfigId');
      } else {
        localStorage.setItem('mobileConfigId', mobileConfigId);
      }
      noti.success('Mobile configuration is saved');
      return true;
    } catch (error) {
      noti.error('Saving mobile configuration unsuccessful');

      return false;
    }
  };
}
